angular.module('mercury.modules.qa.menumate.discountlines', []);
